'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox as AriaKitCheckbox } from '@ariakit/react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { timingDefault } from '../../constants';
import { focusOutline, screenReaderOnly } from '../../utility-classes';
const HiddenSwitchInput = styled.input.attrs({ type: 'checkbox' }) `
  ${screenReaderOnly}
`;
const SwitchLabel = styled.label `
  display: inline-flex;
  align-items: center;
  cursor: ${o => (o.$disabled ? 'not-allowed' : 'pointer')};
  ${focusOutline}

  &:has(${HiddenSwitchInput}[data-focus-visible]) {
    outline-style: solid;
  }
`;
const SwitchTrack = styled.div `
  position: relative;
  width: ${({ $size = 'small' }) => {
    switch ($size) {
        case 'small':
            return '24px';
        case 'medium':
            return '36px';
        case 'large':
            return '51px';
    }
}};
  height: ${({ $size = 'small' }) => {
    switch ($size) {
        case 'small':
            return '16px';
        case 'medium':
            return '24px';
        case 'large':
            return '32px';
    }
}};
  border-radius: 200px;
  transition: background-color ${timingDefault} ease;
  background-color: ${o => o.$disabled
    ? o.theme.color.stroke.neutral.border.decoration.on.background
    : o.$checked
        ? o.theme.color.stroke.neutral.text.primary.on.background
        : o.theme.color.stroke.neutral.border.decoration.on.background};
  pointer-events: none;

  ${o => o.$disabled &&
    `
    opacity: 0.5;
  `}

  /* Thumb element */
  &::before {
    content: '';
    position: absolute;
    width: ${({ $size = 'small' }) => {
    switch ($size) {
        case 'small':
            return '12px';
        case 'medium':
            return '18px';
        case 'large':
            return '24px';
    }
}};
    height: ${({ $size = 'small' }) => {
    switch ($size) {
        case 'small':
            return '12px';
        case 'medium':
            return '18px';
        case 'large':
            return '24px';
    }
}};
    border-radius: 50%;
    background-color: ${o => o.theme.color.fill.background};
    transition: left ${timingDefault} ease;
    left: ${({ $checked, $size = 'small' }) => {
    const thumbWidth = $size === 'small' ? 12 : $size === 'medium' ? 18 : 24;
    const padding = $size === 'small' ? 2 : $size === 'medium' ? 3 : 4;
    return $checked ? `calc(100% - ${thumbWidth}px - ${padding}px)` : `${padding}px`;
}};
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
`;
export const Switch = forwardRef(({ checked, disabled, size, className, onChange, ...props }, ref) => {
    return (_jsxs(SwitchLabel, { "$disabled": disabled, className: className, children: [_jsx(AriaKitCheckbox, { ref: ref, checked: checked, disabled: disabled, accessibleWhenDisabled: true, ...props, render: ({ onChange: checkboxOnChange, ...checkboxProps }) => (_jsx(HiddenSwitchInput, { ...checkboxProps, onChange: event => {
                        checkboxOnChange?.(event);
                        onChange?.(event.target.checked);
                    } })) }), _jsx(SwitchTrack, { "$checked": checked, "$disabled": disabled, "$size": size, "aria-hidden": 'true', role: 'presentation' })] }));
});
//# sourceMappingURL=Switch.js.map